import Dashboard from "views/Dashboard/Dashboard.js";

import Admin from "views/Tables/Admin.js";
import MemberDirectory from "views/Tables/MemberDirectory";
import Projects from "views/Tables/Projects";
import Studies from "views/Tables/Studies";
import DataExport from "views/Tables/DataExport";
import AllStudies from "views/Tables/AllStudies";

import UserProfile from "views/Pages/UserProfile";
import ConferenceRegistration from "views/Pages/ConferenceRegistration";
import Mission from "views/Pages/Mission";
import Leadership from "views/Pages/Leadership";
import Agreement from "views/Pages/Agreement";
import MyConferences from "views/Pages/MyConferences";

import CommonDataElements from "views/Pages/CommonDataElements";
import Stats from "views/Charts/Stats";
import Dino from "views/Pages/Dino";

// @material-ui/icons
import DashboardIcon from "@material-ui/icons/Dashboard";
import People from "@material-ui/icons/People";
import GridOn from "@material-ui/icons/GridOn";
import Timeline from "@material-ui/icons/Timeline";
import Folder from "@material-ui/icons/Folder";

import Event from "@material-ui/icons/Event";
import ConfirmationNumber from "@material-ui/icons/ConfirmationNumber";

var dashRoutes = [
  ///// HIDDEN ROUTES
  {
    path: "/admin",
    name: "Admin",
    icon: DashboardIcon,
    component: Admin,
    layout: "/portal",
  },

  {
    path: "/profile",
    name: "Profile",
    icon: DashboardIcon,
    component: UserProfile,
    layout: "/portal",
  },

  {
    path: "/my_conferences",
    name: "My Conferences",
    icon: DashboardIcon,
    component: MyConferences,
    layout: "/portal",
  },

  {
    path: "/agreement",
    name: "Agreement",
    mini: "",
    component: Agreement,
    layout: "/portal",
  },

  {
    path: "/studies",
    name: "My PALISI Studies",
    icon: DashboardIcon,
    component: Studies,
    layout: "/portal",
  },

  {
    path: "/all_studies",
    name: "All Studies",
    icon: DashboardIcon,
    component: AllStudies,
    layout: "/portal",
  },
  {
    path: "/data_export",
    name: "Data Export",
    icon: DashboardIcon,
    component: DataExport,
    layout: "/portal",
  },

  ////// Visible ROUTES

  {
    path: "/highlights",
    name: "Highlights",
    icon: DashboardIcon,
    component: Dashboard,
    layout: "/portal",
  },
  {
    path: "/mission",
    name: "Mission",
    icon: ConfirmationNumber,
    component: Mission,
    layout: "/portal",
  },
  {
    path: "/leadership",
    name: "Leadership",
    icon: People,
    component: Leadership,
    layout: "/portal",
  },
  {
    path: "/conferences",
    name: "Conferences/Meetings",
    icon: Event,
    component: ConferenceRegistration,
    layout: "/portal",
  },
  {
    path: "/member_directory",
    name: "Member Directory",
    icon: GridOn,
    component: MemberDirectory,
    layout: "/portal",
  },
  {
    collapse: true,
    path: "/projects",
    name: "Projects",
    icon: "content_paste",
    state: "projectsCollapse",
    component: Projects,
    views: [
      {
        path: "/projects",
        name: "Project List",
        mini: "",
        component: Projects,
        layout: "/portal",
      },
      {
        path: "/dino",
        name: "DiNO",
        mini: "",
        component: Dino,
        layout: "/portal",
      },
    ],
    layout: "/portal",
  },

  {
    collapse: true,
    name: "Data Products",
    icon: Folder,
    state: "dataProductsCollapse",
    views: [
      {
        path: "/common_data_elements",
        name: "Common Data Elements",
        mini: "",
        component: CommonDataElements,
        layout: "/portal",
      },
    ],
  },

  {
    path: "/stats",
    name: "Stats",
    icon: Timeline,
    component: Stats,
    layout: "/portal",
  },
];
export default dashRoutes;
